export default __webpack_public_path__ + "static/media/menu1.c4e9effe.jpeg";